import React from "react";
import image from "../../../assests/images/zunun.png";

import SocialMediaLinks from "../../../Components/SocialMediaLinks/SocialMediaLinks";

import "./LoginHeader.scss";

export default function LoginHeader() {
  return (
    <div className="login_header">
      <div className="logo_container">
        <img className="logo" src={image} alt="logo" />
      </div>

      <h1>Student Learner</h1>

      <div className="links_container">
        <h3>Follow us on</h3>
        <SocialMediaLinks />
      </div>
    </div>
  );
}
